import styled from "styled-components";

export const ContainerGrid = styled.div`
    margin-top: 10vh;
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    grid-row-gap: 1vh;
    margin-left: auto;
    margin-right: auto;
`